/**
 * useCaptchaConfig Hook
 *
 * Captcha yapılandırmasını CaptchaConfigProvider üzerinden alır (tek istek).
 * Provider yoksa fallback olarak kendi fetch'ini yapar (test/edge case).
 */

import { useContext } from 'react';
import { CaptchaConfigContext, useCaptchaConfigContext } from '@/contexts/CaptchaConfigContext';
import { useCaptchaConfigFallback } from './useCaptchaConfigFallback';

export type { CaptchaConfig, UseCaptchaConfigReturn } from './useCaptchaConfigFallback';

/**
 * Provider içindeyse context'ten config döner (tek /api/captcha/config isteği).
 * enabled=false ise config null, loading false.
 * CaptchaConfigContext undefined ise (modül sırası) doğrudan fallback kullanılır.
 */
export function useCaptchaConfig(enabled: boolean = true) {
  const context = useContext(CaptchaConfigContext);
  const useFallback = context === undefined;
  const fallback = useCaptchaConfigFallback(useFallback && enabled);

  if (context !== undefined) {
    if (!enabled) {
      return {
        config: null,
        isLoading: false,
        error: null,
        refetch: context.refetch,
      };
    }
    return context;
  }

  return fallback;
}

// Re-export for components that need the context directly
export { useCaptchaConfigContext };

